<template>
	<div class="games-section">
		<transition-group class="list-unstyled games-list-section" tag="ul" name="fade-out-in">
			<li v-for="(allGame, index) in selectedGameList" :key="`${selectedFilter}-${allGame.name}-${index}`" class="games-list">
				<a :class="allGame.name" :href="navToDetails(allGame.name)" class="game-details-link" @click="onGame(allGame)">
					<div class="icon" :style="{ backgroundImage: `url(${cdnHost}${allGame.navigationGameIcon})` }"></div>
					<div>
						<div class="game-title-section">
							<span class="game-title"
								>{{ allGame.name
								}}<span v-if="allGame.isNewGame" class="new-game text-uppercase">{{ $t('navigation.new') }}</span></span
							>
						</div>
						<div class="platform-icons">
							<div v-if="allGame.pc || allGame.steam" class="platform-icon">
								<svgIcon icon-holder-class="icon-ext-windows" icon-id="icon-ext-windows" />
							</div>
							<div v-if="allGame.xbox" class="platform-icon">
								<svgIcon icon-holder-class="icon-ext-xbox" icon-id="icon-ext-xbox" />
							</div>
							<div v-if="allGame.psn" class="platform-icon">
								<svgIcon icon-holder-class="icon-psn" icon-id="icon-psn" />
							</div>
							<div v-if="allGame.ios" class="platform-icon">
								<svgIcon icon-holder-class="icon-apple" icon-id="icon-apple" />
							</div>
							<div v-if="allGame.android" class="platform-icon">
								<svgIcon icon-holder-class="icon-ext-android" icon-id="icon-ext-android" />
							</div>
						</div>
					</div>
				</a>
			</li>
		</transition-group>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import config from '@/config/config-navigation';
export default {
	name: 'GameList',
	components: {
		svgIcon,
	},
	props: {
		selectedFilter: {
			type: String,
			default: '',
		},
		selectedGameList: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			domain: config.domain,
		};
	},
	methods: {
		onGame(gameLink) {
			dataLayer.push({
				event: 'GNB Game Link Clicked',
				gnbGameName: gameLink.name,
				gnbGameID: gameLink.productId,
			});
		},
		navToDetails(gameTitle) {
			let locale = this.$i18n.locale || this.$cookie.get('i18next');
			if (!gameTitle || !locale) return '';
			return `${this.domain}/main/${locale}/${gameTitle}/details`;
		},
	},
};
</script>

<style lang="less" scoped>
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
.games-section {
	// scroll bar style
	&::-webkit-scrollbar {
		width: 8px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.5);
		border-radius: 5px;
		border: solid 1px rgba(255, 255, 255, 0.27);
	}
	&::-webkit-scrollbar-thumb:hover {
		border: solid 1px rgba(255, 255, 255, 0.4);
		background: rgba(0, 0, 0, 1);
	}

	// game list animation
	.fade-out-in-enter-active,
	.fade-out-in-leave-active {
		transition: opacity 0.3s;
	}

	.fade-out-in-enter-active {
		transition-delay: 0.3s;
	}

	.fade-out-in-enter,
	.fade-out-in-leave-to {
		opacity: 0;
	}

	overflow-y: auto;
	overflow-y: overlay;
	height: calc(100% - 77px);
	padding: 0px 10px;
	.games-list-section {
		margin-bottom: 30px;
		.games-list {
			height: 70px;
			margin-bottom: 10px;
			position: relative;
			.game-details-link {
				display: flex;
				// align-items: center;
				width: 100%;
				height: 100%;
				color: #dcdcdc;
				padding: 13px 15px;
				transition: 0.2s ease;
				border: solid 1px transparent;
				font-family: Roboto;
				font-size: 13.5px;
				&:hover {
					border-radius: 5px;
					border: solid 1px #0077ff;
				}
				&:active {
					opacity: 0.5;
				}
				.icon {
					width: 44px;
					height: 44px;
					background-repeat: no-repeat;
					background-size: contain;
					margin-right: 15px;
				}
				.game-title-section {
					max-width: 223px;
					line-height: 1.37;
					.game-title {
						display: flex;
						align-items: center;
						.new-game {
							margin-left: 6px;
							color: #ffa223;
							font-size: 10px;
						}
					}
				}
				.platform-icons {
					display: flex;
					.platform-icon {
						margin: 8px 3px;
						line-height: 1;
						opacity: 0.3;

						.icon-ext-windows {
							width: 10px;
							height: 11px;
							margin-top: 1px;
						}
						.icon-ext-xbox {
							width: 11px;
							height: 11px;
							margin-top: 1px;
						}
						.icon-psn {
							width: 13px;
							height: 12px;
							margin-top: 1px;
						}
						.icon-apple {
							width: 11px;
							height: 12px;
						}
						.icon-ext-android {
							width: 11px;
							height: 12px;
						}
					}
					.platform-icon:first-child {
						margin: 8px 3px 0 0;
					}
				}
			}
		}
	}
}
@media (min-width: 1024px) {
	.games-section {
		padding-left: 40px;
		padding-right: 40px;
		.games-list-section {
			display: flex;
			flex-wrap: wrap;
			margin: 0px 0px 30px 0px;
			padding: 0px;
			list-style-type: none;
			align-content: stretch;
			width: 100%;
			.games-list {
				position: relative;
				margin: 10px;
				flex-basis: calc(35% - 40px);
			}
		}
	}
}

@media (min-width: 1280px) {
	.games-section {
		.games-list-section {
			.games-list {
				flex-basis: calc(25% - 20px);
			}
		}
	}
}
@media (min-width: 1440px) {
	.games-section {
		.games-list-section {
			margin: 0px auto;
			max-width: 1360px;
		}
	}
}
</style>
